import { Button } from '@mui/material';
import { Link } from 'react-router';

import { checkoutRoutesConfig } from 'domains/checkout/routes';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { getPremiumButtonTranslation } from './translation';
import { useGetPremiumButtonStyles } from './useGetPremiumButtonStyles';

export interface GetPremiumButtonProps {
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
}

export const GetPremiumButton = ({
  className,
  fullWidth,
  onClick,
}: GetPremiumButtonProps) => {
  const { keys, t } = useTranslation(getPremiumButtonTranslation);

  const { classes, cx } = useGetPremiumButtonStyles();

  return (
    <>
      <Button
        className={cx(classes.root, className)}
        component={Link}
        fullWidth={fullWidth}
        onClick={onClick}
        size="small"
        to={checkoutRoutesConfig.checkout.generatePath()}
        variant="contained"
      >
        {t(keys.label)}
      </Button>
    </>
  );
};
